import React, { Component } from "react";
// import { connect } from "react-redux";
// import { userLogin, Login } from "react-admin";
import { ThemeProvider } from "@mui/styles";
import login_navender_logo from "./images/navender_logo.png";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "./common/common";
const apiUrl = RUN_TIME_API_ENDPOINT;

class MyNewLoginPage extends Component {
  state = {
    email: "",
    password: "",
    emailError: false,
    passwordError: false,
    validFields: false,
    accessBlocked: false,
    unauthorized: false,
    showLoader: false,
    emptyEmail: false
  };

  validateFields = (email, pwd) => {
    console.log("inside validateFields");
    let validFields = false;
    let emailError = false;
    let passwordError = false;
    let emptyEmail = false;
    const emailRegex = RegExp(
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    );
    console.log('asaasa===>', emailRegex.test(email))
  
    console.log('email ====>', email === '');
    if (email === '') {
      emptyEmail = true;
      validFields = false;
      emailError = false;
      passwordError = false;
    } else if (!emailRegex.test(email)) {
      console.log("email inside validateFields===>", email);
      emptyEmail = false;
      validFields = false;
      emailError = true;
      passwordError = false;
    } else if (!pwd) {
      console.log("pwd inside validateFields===>", pwd);
      emptyEmail = false;
      validFields = false;
      passwordError = true;
      emailError = false;
    } else if (email && pwd) {
      emptyEmail = false;
      validFields = true;
      emailError = false;
      passwordError = false;
    }
    // this.setState({
    //     validFields,
    //     emailError,
    //     passwordError,
    // }, () => this.state.validFields)
    return { validFields, emailError, passwordError, emptyEmail };
  };

  submit = (e) => {
    const { state } = this;
    // console.log('email inside submit=====>', state.email);
    // console.log('pwd inside submit=====>', state.password);
    console.log("inside submit===>");
    let url = "";
    e.preventDefault();
    const checkFields = this.validateFields(state.email, state.password);
    this.setState({
      // showLoader: true,
      ...checkFields,
    });
    if (checkFields.validFields) {
      this.setState({
        showLoader: true,
      });
      url = `${apiUrl}/login`;
      const options = CommonHeaderOption();
      options.method = "POST";
      options.headers = {
        // 'authorization': tokenId,
        "Content-Type": "application/json",
      };
      options.body = JSON.stringify({
        email: this.state.email,
        password: this.state.password,
      });
      return fetch(url, options)
        .then((res) => {
          console.log("res inside new login===>", res);
          if (res.status == 403) {
            this.setState({
              showLoader: false,
              accessBlocked: true,
              unauthorized: false,
            });
            // throw new Error(res.statusText);
          } else if (res.status == 401) {
            this.setState({
              showLoader: false,
              unauthorized: true,
              accessBlocked: false,
            });
          } else {
            this.setState({
              showLoader: false,
              unauthorized: false,
              accessBlocked: false,
            });
          }
          return res.json();
        })
        .then((resp) => {

          // console.log('our use ', resp);
          if (resp.status === "success") {
            this.setState({
              showLoader: false,
            });
            console.log("resp inside new login===>", resp);
            window.location.href = "/#";
            localStorage.setItem("__state", JSON.stringify(resp.data));
          }
        })
        .catch((error) => {
          this.setState({
            showLoader: false,
          });
          localStorage.removeItem("__state");
        });
    }
  };

  handleEmail = (e) => {
    const emailRegex = RegExp(
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    );
    // emailRegex.test(e.target.value) ? this.setState({emailError: false}) : this.setState({emailError: true});
    this.setState({
      email: e.target.value,
      showLoader: false,
    }, () => {
      this.validateFields(this.state.email, this.state.password)
    });
  };

  handlePassword = (e) => {
    this.setState({
      password: e.target.value,
      showLoader: false,
    });
  };

  render() {
    const { state } = this;
    return (
      <React.Fragment>
        <ThemeProvider theme={this.props.theme}>
          <div className="email-login-page">
            <div>
              <img src={login_navender_logo} />
            </div>
            <div className="email-login-form">
              <form onSubmit={this.submit}>
                <div>
                  <label for="fname">
                    Email<sup className="asterisk">*</sup>
                  </label>
                  <input
                    name="email"
                    type="email"
                    value={state.email}
                    onChange={this.handleEmail}
                  />
                  {state.emailError && (
                    <div className="email-login-error">{"Invalid Email"}</div>
                  )}
                  {state.emptyEmail && (
                    <div className="email-login-error">{"Email cannot be empty"}</div>
                  )}
                </div>
                <div>
                  <label for="fname">
                    Password<sup className="asterisk">*</sup>
                  </label>
                  <input
                    name="password"
                    type="password"
                    value={state.password}
                    onChange={this.handlePassword}
                  />
                  {state.passwordError && (
                    <div className="email-login-error">
                      {"Password cannot be empty"}
                    </div>
                  )}
                </div>
                <div className="forgot-password">
                  <a href={`#/forgot-password`}>Forgot Password ?</a>
                </div>
                <div>
                  <button className="email-login-button" type="submit">
                    Login
                  </button>
                </div>
                {state.unauthorized && (
                  <div className="email-login-error-centered">
                    {"Unauthorized User"}
                  </div>
                )}
                {state.accessBlocked && (
                  <div className="email-login-error-centered">
                    {
                      "Access temporarily blocked due to security reasons. Please try again after 1 hour."
                    }
                  </div>
                )}
                {state.showLoader &&
                  !state.unauthorized &&
                  !state.accessBlocked && <div className="login-loader" />}
              </form>
            </div>
          </div>
        </ThemeProvider>
      </React.Fragment>
    );
  }
}
export default MyNewLoginPage;
